
import DocumentCopy from "../../../assets/duotone/DocumentCopy.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DocumentCopyIcon({ className, dataTestid = "DocumentCopyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DocumentCopy data-testid={dataTestid} className={classes} {...rest} />
  );
}
